import { Controller } from "@hotwired/stimulus";

export default class NumericController extends Controller {
  static values = {
    allowDecimal: { type: Boolean, default: false }
  };

  connect() {
    this.element.addEventListener("keydown", this.validateKey);
    if(this.element.dataset.validateDecimal) {
      this.element.addEventListener("input", this.validateDecimal); // prevent adding the additional decimal value
    }
  }

  disconnect() {
    this.element.removeEventListener("keydown", this.validateKey);
    if(this.element.dataset.validateDecimal) {
      this.element.removeEventListener("input", this.validateDecimal);
    }
  }

  validateKey = (event) => {
    const allowedKeys = [
      "Backspace",
      "Enter",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "Tab"
    ];

    if (/^\d$/.test(event.key) || allowedKeys.includes(event.key)) {
      return;
    }

    // Allow a decimal point only when enabled and only once.
    if (
      this.allowDecimalValue &&
      event.key === "." &&
      !this.element.value.includes(".")
    ) {
      return;
    }

    event.preventDefault();
  };

  validateDecimal = (event) => {
    const value = event.target.value;
    const decimalIndex = value.indexOf(".");

    if (decimalIndex !== -1) {
      const decimalPlaces = value.length - decimalIndex - 1;

      if (decimalPlaces > 2) {
        event.target.value = value.slice(0, decimalIndex + 3);
      }
    }
  };
}
